module.exports = __webpack_public_path__ + "static/img/7833_phase_function_Paper_PointsHejduk_Prediction.36d3e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7833_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FP8p
// module chunks = 0